import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Forms_CustomerInquiryRequest,
  RequestModels_Forms_FormsRequestModel,
  ResponseDataSystem_Guid,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type PostInquiry = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Forms_CustomerInquiryRequest;
  recaptchaEnterpriseToken?: string;
};
/**
 * Post public inquiry with possible attachments.
Customer ID can be included in the request model
 * 
 * @returns ResponseDataSystem_Guid Success
 */
export function postInquiry(
  { businessUnit, label, requestBody, recaptchaEnterpriseToken }: PostInquiry,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataSystem_Guid> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/forms/inquiry`,
      body: requestBody,
      headers: { recaptchaEnterpriseToken },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type PostCustomerInquiry = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody: RequestModels_Forms_CustomerInquiryRequest;
  recaptchaEnterpriseToken?: string;
};
/**
 * Post Customer Inquiry with possible attachments
 *
 * @returns ResponseDataSystem_Guid Success
 */
export function postCustomerInquiry(
  { businessUnit, label, customerId, requestBody, recaptchaEnterpriseToken }: PostCustomerInquiry,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataSystem_Guid> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/customers/${customerId}/forms/inquiry`,
      body: requestBody,
      headers: { recaptchaEnterpriseToken },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type PostForm = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  formId: string;
  requestBody: RequestModels_Forms_FormsRequestModel;
  recaptchaEnterpriseToken?: string;
};
/**
 * post the form
 *
 * @returns void
 */
export function postForm(
  { businessUnit, label, formId, requestBody, recaptchaEnterpriseToken }: PostForm,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/forms/${formId}`,
      body: requestBody,
      headers: { recaptchaEnterpriseToken },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
